import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { Select, SelectItem, SelectedItems } from '@backstage/core-components';

interface DialogEditTechnologyProps {
  open: boolean;
  technology: string;
  onClose: () => void;
  onSave: (technology: string) => void;
}

export function DialogEditTechnology(
  props: Readonly<DialogEditTechnologyProps>,
) {
  const [technology, setTechnology] = useState<SelectedItems>();
  const technologyItems: SelectItem[] = [
    { label: '---', value: '' },
    { label: 'Nodejs', value: 'Nodejs' },
    { label: 'Java', value: 'Java' },
    { label: 'Python', value: 'Python' },
    { label: 'PostgreSQL', value: 'PostgreSQL' },
    { label: 'MySQL', value: 'MySQL' },
    { label: 'Other', value: 'Other' },
  ];
  const initialSelection = technologyItems.find(
    it => it.value === props.technology,
  );

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Change Technology</DialogTitle>
      <DialogContent>
        <Select
          label="Technology"
          items={technologyItems}
          onChange={(e: SelectedItems) => {
            setTechnology(e);
          }}
          multiple={false}
          selected={initialSelection ? props.technology : 'Other'}
        ></Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button onClick={() => props.onSave(technology as string)}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
